<template>
    <div
        @focusin="onFocus"
        @focusout="onFocusout"
    >
        <show-all-new
            :title="pageTitle"
            :items="channelItems"
            :is-loading="isLoading"
            @item-selected="itemsSelected"
            @request-more="fetchMoreItems"
        />
    </div>
</template>

<script setup lang="ts">
    import { Strings } from '@/locales/types/enums';
    import { linkItems } from "@/components/Header/types/LinkItemsCollection";
    import { useI18n } from "vue-i18n";
    import { useShowAllMyTvChannelsStore } from "@/stores/ShowAllMyTvChannels";
    import { storeToRefs } from 'pinia';
    import  { 
        type NavigationGuardNext, 
        type RouteLocationNormalizedGeneric, 
        type RouteLocationNormalizedLoadedGeneric, 
        useRouter,
        onBeforeRouteLeave 
    } from "vue-router";
    import { usePlayerStore } from "@/stores/Player";
    import type { IEventSelected } from "@/components/MultiLineView/types";
    import { type ChannelLiveCardData} from "@/components/Cards/types";


    definePageMeta({ 
        layout: 'default-no-header',
        middleware: ['set-page-indicator'],
    });

    const ShowAllMyTvChannelsStore = useShowAllMyTvChannelsStore();
    const {
        loadFavoritesChannelsNextPage,
        clearAll
    } = ShowAllMyTvChannelsStore;
    const {
        getCardsChannels: channelItems,
        getIsFavoritesChannelsLoading: isLoading,
    } = storeToRefs(ShowAllMyTvChannelsStore);
    const PlayerStoreModule = usePlayerStore();
    const {
        startPlayingChannel,
    } = PlayerStoreModule;

    const { t } = useI18n();
    const router = useRouter();
    const { $navigator } = useNuxtApp();
    const pageTitle: string = t(Strings.MY_TV_FAVORITE_CHANNELS).toString();

    
    const fetchMoreItems = async (): Promise<void> => {
        await loadFavoritesChannelsNextPage();
    };
    const itemsSelected = (event: IEventSelected): void => {
        const item = event.item as ChannelLiveCardData;
        void startPlayingChannel(item);
    };
    const onFocus = (): void => {
        registerKeyListeners();
    };
    const onFocusout = (): void => {
        unregisterKeyListeners();
    };
    const keyBackListener = (): void => {
        router.go(-1);
    };
    const registerKeyListeners = (): void => {
        $navigator.on("keypress:back", keyBackListener);
    };
    const unregisterKeyListeners = (): void => {
        $navigator.off("keypress:back", keyBackListener);
    };
    onBeforeRouteLeave((to: RouteLocationNormalizedGeneric, _from: RouteLocationNormalizedLoadedGeneric, next: NavigationGuardNext) => {
        if(to.path === linkItems.myTv.routerPath) {
            clearAll();
        }
        next();
    });
</script>
